import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SearchSvg } from "../../../svgFiles/SearchSvg";
import Button from "../../../components/shared/buttons/button";
import { AddSvg } from "../../../svgFiles/AddSvg";
import VaDistributorTable from "../../../components/va-distributors/VaDistributorTable";
import AddVaDistributorModal from "../../../components/va-distributors/AddVaDistributorModal";
import VaDistributorCommissionHistoryModal from "../../../components/va-distributors/VaDistributorCommissionHistoryModal";
import MetricsPeriodFilter from "../../../components/distributor/MetricsPeriodFilter";
import { useVaDistributors } from "../../../hooks/useVaDistributors";
import { useDebounce } from "../../../helpers/Utils";
import { navigateToVaDistributorDetails } from "../../../helpers/vaDistributorNavigation";
import "./vaDistributors.css";
import "../../distributor/distributor.css";

const PAGE_SIZE = 20;
const DEFAULT_PERIOD_FILTER = { period: "this_month" };

export default function VaDistributorsPage() {
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [periodFilter, setPeriodFilter] = useState(DEFAULT_PERIOD_FILTER);
  const [showModal, setShowModal] = useState(false);
  const [historyDistributor, setHistoryDistributor] = useState(null);
  const debouncedSearch = useDebounce(searchInput, 400);
  const {
    items,
    page,
    setPage,
    setSearch,
    total,
    totalPages,
    isLoading,
    isError,
    refetch,
  } = useVaDistributors(1, PAGE_SIZE, periodFilter);

  useEffect(() => {
    setSearch(debouncedSearch);
    setPage(1);
  }, [debouncedSearch, setSearch, setPage]);

  useEffect(() => {
    setPage(1);
  }, [periodFilter, setPage]);

  return (
    <div className="va-distributors-page">
      <p className="va-distributors-page__crumb mb-3">VA Distributors</p>

      <div className="va-distributors-card">
        <div className="va-distributors-toolbar">
          <div className="va-distributors-toolbar__filters d-flex align-items-center gap-2 flex-wrap">
            <div className="va-distributors-period-filter">
              <MetricsPeriodFilter
                value={periodFilter}
                onChange={setPeriodFilter}
                emptyLabel="This month"
              />
            </div>
            <div className="search va-distributors-search d-flex align-items-center gap-2">
              <SearchSvg />
              <input
                type="search"
                className="w-100"
                placeholder="Search"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap">
            <Button
              label="Add New Distributor"
              icon={<AddSvg />}
              onClick={() => {
                setShowModal(true);
              }}
            />
          </div>
        </div>

        {isError ? (
          <div className="text-center py-5">
            <p className="text-danger mb-3">Failed to load distributors</p>
            <Button label="Retry" onClick={refetch} />
          </div>
        ) : (
          <VaDistributorTable
            items={items}
            isLoading={isLoading}
            page={page}
            pageSize={PAGE_SIZE}
            totalPages={totalPages}
            total={total}
            onPageChange={setPage}
            onEdit={(row) => navigateToVaDistributorDetails(navigate, row.id)}
            onCommissionHistory={setHistoryDistributor}
          />
        )}
      </div>

      <AddVaDistributorModal
        show={showModal}
        setShow={setShowModal}
        onSuccess={refetch}
        onCreated={(id) => navigateToVaDistributorDetails(navigate, id)}
      />

      <VaDistributorCommissionHistoryModal
        show={Boolean(historyDistributor)}
        setShow={(next) => {
          if (!next) setHistoryDistributor(null);
        }}
        distributor={historyDistributor}
      />
    </div>
  );
}
